/**
 * Parse a WebVTTCueIdBox from an IsoView
 *
 * @param view - The IsoView to read data from
 *
 * @returns A parsed WebVTTCueIdBox
 *
 * @group ISOBMFF
 *
 * @beta
 */
export function iden(view) {
    return {
        cueId: view.readUtf8(-1),
    };
}
;
//# sourceMappingURL=iden.js.map